<template>
  <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
      <h3 slot="header" class="mb-0 font-weight-500">Create New Email Template</h3>

      <ValidationObserver v-slot="{ invalid }" ref="observer">
          <b-form @submit.prevent="submit" ref="notifTemplatesForm">
               <!-- Form fields -->
          <div>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Message">
                <base-input
                  type="text"
                  placeholder="Message"
                  v-model="setupForm.notif_temp_message"
                ></base-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Notification Receivers">
                <el-select v-model="notifReceiver" multiple placeholder="Receiver" filterable>

                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Trigger Point">
                <b-form-select
                  v-model="setupForm.triggerPoint"
                  :options="notificationTriggerPointOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Active or Not Active">
                <b-form-checkbox
                  v-model="setupForm.toggle"
                  switch
                  class="ml-5"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" />
        <div class="text-right">
          <base-button type="primary" v-if="setupForm.notif_temp_id === null" @click="saveSetupData">Save</base-button>
        </div>
          </b-form>
      </ValidationObserver>
  </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Checkbox } from 'element-ui'
import { 
  notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { mapState , mapActions} from "pinia";
import { useAccessControlStore } from "@/stores/accessControlStore";
import { EMAIL_TRIGGER_POINTS , NOTIFICATION_TRIGGER_POINTS } from "@/assets/js/status.js";
import { useNotificationStore } from '@/stores/notificationStore'

export default {
  props:{
    create_new_notif_templates: Boolean
  },
  mixins:[
      notifyFunctionMixin,
      helperFunctionMixin
  ],
  components: {
      Modal,
      ValidationObserver,
      ValidationProvider,
      [Select.name]: Select,
      [Option.name]: Option,
      [Checkbox.name]: Checkbox,
  },
  async created() {
    const notificationStore = useNotificationStore();
    // await notificationStore.fetchExistingData();

  },
  computed: {
    ...mapState(useAccessControlStore, ["userList"]), 
    show: {
          get() {
              return this.create_new_notif_templates;
          },
          set(newVal) {
              this.$emit('update:create_new_notif_templates', newVal);
          },
      },
    userEmailOptions() {
      return this.userList.map(user => ({
        value: user.email,
        text: user.email,
      }));
    },
    notifReceiver: {
      get() {
        return this.setupForm.notif_temp_receiver.map(Number);
      },
      set(val) {
        this.setupForm.notif_temp_receiver = val.map(String);
      },
    },
    emailTriggerPointOptions() {
      return Object.keys(EMAIL_TRIGGER_POINTS).map(key => ({
        value: key,
        text: EMAIL_TRIGGER_POINTS[key],
      }));
    },
    notificationTriggerPointOptions() {
      return Object.keys(NOTIFICATION_TRIGGER_POINTS).map(key => ({
        value: key,
        text: NOTIFICATION_TRIGGER_POINTS[key],
      }));
    },
  },
  data() {
      return {
        setupForm: {
        notif_temp_id: null, // Store the id of the existing setup
        notif_temp_message: "",
        notif_temp_receiver: [],
        triggerPoint: "", // Will be converted to trigger_point before sending
        toggle: true, // Default value for the toggle
      },
      }
  },
  methods: {
    ...mapActions(useNotificationStore, ['fetchExistingData','saveEmail','updateEmail','saveNotification','updateNotification']),

    async saveSetupData() {
      try {
        const notif_temp_receiver = this.setupForm.notif_temp_receiver.map(receiver => receiver === null ? '0' : receiver);

        const payload = {
          ...this.setupForm,
          notif_temp_type: 'bell', // Adding the type field
          is_active: this.setupForm.toggle ? '1' : '0', // Set is_active based on the toggle state
          notif_temp_receiver: notif_temp_receiver.join(','), // Convert array to string
          trigger_point: this.setupForm.triggerPoint, // Rename to trigger_point
          notif_assign_advisor: this.notif_assign_advisor !== undefined ? this.notif_assign_advisor : 0,
        };
        await this.saveNotification(payload);
        this.notifySuccess("Data saved successfully.");
        this.$emit('closeNotifModal', false)
        mainEventBus.$emit('refresh-status')
        this.resetFormToNull(this.setupForm)
        this.setupForm.notif_temp_receiver = [];


    } catch (e) {
        console.log('Failed to save notification:', error);
    }
  }
}
}
</script>